function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import lottie from 'lottie-web';
import PropTypes from 'prop-types';
import React from 'react';
import Box from './Box';
const LottiePlayer = /*#__PURE__*/React.memo(_ref => {
  let {
    animationData,
    autoplay,
    loop,
    options,
    ...props
  } = _ref;
  const containerRef = React.useRef(null);
  React.useLayoutEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop,
      autoplay,
      animationData,
      ...options
    });
    return () => animation.destroy();
  }, [animationData, autoplay, loop, options]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    style: {
      transform: 'translate3d(0,0,0)'
    }
  }, props, {
    ref: containerRef
  }));
});
LottiePlayer.propTypes = {
  ...Box.propTypes,
  animationData: PropTypes.any.isRequired,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  options: PropTypes.object
};
LottiePlayer.defaultProps = {
  autoplay: true,
  loop: true,
  options: {}
};
LottiePlayer.displayName = 'LottiePlayer';
export default LottiePlayer;